<div class="list-item" (click)="onBackgroundClick($event)">
	<span class="ng-content" (click)="onBackgroundClick($event)">
		@if (enableSelect) {
			<button nz-button nzType="text" nzShape="circle" nzSize="small" title="Select" (click)="select($event)">
				<span nz-icon [nzType]="isLeaf ? 'file' : 'folder'" nzTheme="outline"></span>
			</button>
		}

		<span class="item">
			@if (prefix) {
				<span class="prefix">{{ prefix }}</span>
			}
			<ng-content></ng-content>
		</span>
	</span>

	<span class="buttons">
		@if (enablePreview) {
			<button nz-button nzType="text" nzShape="circle" nzSize="small" title="Preview" (click)="preview()">
				<span nz-icon nzType="export" nzTheme="outline"></span>
			</button>
		}

		@if (enableUpDown) {
			<button nz-button nzType="text" nzShape="circle" nzSize="small" title="Move Up" (click)="moveUp($event)">
				<span nz-icon nzType="up" nzTheme="outline"></span>
			</button>
		}

		@if (enableUpDown) {
			<button
				nz-button
				nzType="text"
				nzShape="circle"
				nzSize="small"
				title="Move Down"
				(click)="moveDown($event)"
			>
				<span nz-icon nzType="down" nzTheme="outline"></span>
			</button>
		}

		@if (enableCopy) {
			<button nz-button nzType="text" nzShape="circle" nzSize="small" title="Copy" (click)="copy($event)">
				<span nz-icon nzType="copy" nzTheme="outline"></span>
			</button>
		}

		@if (enableEdit) {
			<button nz-button nzType="text" nzShape="circle" nzSize="small" (click)="edit($event)" title="Edit">
				<span nz-icon nzType="edit" nzTheme="outline"></span>
			</button>
		}

		@if (enableDelete) {
			<button
				nz-button
				nzType="text"
				nzShape="circle"
				nzSize="small"
				nz-popconfirm
				nzPopconfirmTitle="Are you sure delete this?"
				nzPopconfirmPlacement="bottom"
				(nzOnConfirm)="delete()"
				title="Delete"
				[disabled]="isInProgress && !canWeDeleteInProgressCourseWork"
				[nz-tooltip]="
					isInProgress && !canWeDeleteInProgressCourseWork
						? 'You cannot delete this item because it is in progress.'
						: ''
				"
			>
				<span nz-icon nzType="delete" nzTheme="outline"></span>
			</button>
		}
	</span>
</div>
